"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 19.64"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22 2v15.64H2V2h20m.1-2H1.9A1.9 1.9 0 000 1.9v15.84a1.9 1.9 0 001.9 1.9h20.2a1.9 1.9 0 001.9-1.9V1.9A1.9 1.9 0 0022.1 0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.33 13.51a3.69 3.69 0 01-1.25-.21 2.72 2.72 0 01-1-.64 2.89 2.89 0 01-.68-1 4 4 0 01-.24-1.45 3.81 3.81 0 01.24-1.48A2.94 2.94 0 017.1 7a3.32 3.32 0 011.23-.23A2.64 2.64 0 019.54 7a3.28 3.28 0 01.84.59l-.77.94a3.62 3.62 0 00-.53-.37 1.48 1.48 0 00-.7-.16 1.6 1.6 0 00-.7.15 1.44 1.44 0 00-.54.41 1.75 1.75 0 00-.36.66 3 3 0 00-.12.88 2.43 2.43 0 00.45 1.57 1.67 1.67 0 001.38.55 1.31 1.31 0 00.39-.05.75.75 0 00.31-.17v-1.08H8.11v-1.2h2.38v3a2.77 2.77 0 01-.91.56 3.13 3.13 0 01-1.25.23zM11.83 13.39V6.87h1.48v6.52zM14.84 13.39V6.87H19v1.24h-2.68v1.51h2.26v1.24h-2.26v2.53z"
  }))));
};

exports["default"] = _default;